export default {
    default: {
        borderRadius: 'large',
        '& .table-row:last-of-type': {
            border: 'none',
            borderBottomLeftRadius: 'large',
            borderBottomRightRadius: 'large',
        },
    },
    flattened: {
        borderRadius: 0,
    },
};
